import * as React from 'react';
import MediaQuery from 'react-responsive';
import { Accordion, AccordionContent, AccordionHeader, AccordionItem, AccordionTitle } from '@telia-front/accordion';
import Separator from '@telia-front/separator';
import { Table } from '@telia-front/table';
import { ThemeContext } from '@telia-front/theme-provider';
class TableColumnCollapse extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isMounted: false,
        };
    }
    componentDidMount() {
        this.setState({
            isMounted: true,
        });
    }
    BEM() {
        const classArray = ['table-column-collapse'];
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    renderTable() {
        return React.createElement(Table, Object.assign({}, this.props.table), this.props.children);
    }
    getRows() {
        const theadRows = [];
        const tbodyRows = [];
        React.Children.forEach(this.props.children, (child) => {
            if (typeof child === 'string' || typeof child === 'number') {
                return;
            }
            if (child.type === 'thead') {
                React.Children.forEach(child.props.children, (theadRow) => {
                    if (typeof theadRow === 'string' || typeof theadRow === 'number') {
                        return;
                    }
                    theadRows.push(theadRow);
                });
            }
            if (child.type === 'tbody') {
                React.Children.forEach(child.props.children, (tbodyRow) => {
                    if (typeof tbodyRow === 'string' || typeof tbodyRow === 'number') {
                        return;
                    }
                    tbodyRows.push(tbodyRow);
                });
            }
        });
        return { theadRows, tbodyRows };
    }
    renderAccordion() {
        const rows = this.getRows();
        const theadCells = rows.theadRows[0].props.children;
        const accordionGroups = theadCells.map((cell) => {
            return {
                content: [],
                header: {
                    content: cell.props.children,
                    id: cell.props.id,
                },
            };
        });
        rows.tbodyRows.forEach((row) => {
            let nextIndex = false;
            React.Children.forEach(row.props.children, (cell, colIndex) => {
                if (typeof cell === 'string' || typeof cell === 'number') {
                    return;
                }
                const cellContent = cell.props.children;
                // if cell has colSpan property
                if (cell.props.colSpan) {
                    let index = colIndex;
                    // if previous cell had colSpan property
                    if (nextIndex) {
                        index = nextIndex;
                    }
                    // duplicate content for each accordion for the amount of colSpan
                    for (let i = 0; i < cell.props.colSpan; i++) {
                        accordionGroups[index + i].content.push(cellContent);
                    }
                    // remember where the last colSpan cell was put, and continue from there for the next iteration
                    nextIndex = index + cell.props.colSpan;
                    return;
                }
                // if previous cell had colSpan property
                if (nextIndex) {
                    accordionGroups[nextIndex].content.push(cellContent);
                    // if is last cell, set flag to false, otherwise increase
                    if (nextIndex + 1 < theadCells.length) {
                        nextIndex++;
                    }
                    else {
                        nextIndex = false;
                    }
                    return;
                }
                accordionGroups[colIndex].content.push(cellContent);
            });
        });
        const accordionItems = accordionGroups.map((item, index) => (React.createElement(AccordionItem, { key: index, id: item.header.id },
            React.createElement(AccordionHeader, null,
                React.createElement(AccordionTitle, null, item.header.content)),
            React.createElement(AccordionContent, null,
                React.createElement(React.Fragment, null,
                    React.createElement(Separator, { color: "invisible", spacing: "xxsmall" }),
                    this.getAccordionContent(item.content))))));
        return React.createElement(Accordion, Object.assign({}, this.props.accordion), accordionItems);
    }
    getAccordionContent(content) {
        return content.map((cell, index) => {
            const isLastItem = content.length - 1 === index;
            return (React.createElement(React.Fragment, { key: index },
                cell,
                !isLastItem && React.createElement(Separator, { spacing: "small", weight: "thin" })));
        });
    }
    renderContent() {
        return (React.createElement(MediaQuery, { minWidth: this.context.media.width[this.props.break].min }, matches => (matches ? this.renderTable() : this.renderAccordion())));
    }
    render() {
        return React.createElement("div", { className: this.BEM() }, this.state.isMounted ? this.renderContent() : this.renderTable());
    }
}
TableColumnCollapse.contextType = ThemeContext;
TableColumnCollapse.defaultProps = {
    break: 'lg',
};
export default TableColumnCollapse;
